export default __webpack_public_path__ + "af4fbcdf4a7e9c8454e2e4f5866a76e2.svg";